import React from 'react';
import styles from './Anamnesis.module.scss';
import { useTranslation } from '../../hooks/useTranslations';
interface Props {
  groupId: string;
  question_id: string;
  question: string;
  label: string;
  answer: string;
  answerCheckbox: boolean;
  onChange: (groupId: string, questionId: string, value: string, checkbox: boolean | null) => void;
  required: boolean;
}

export default function AnamnesisForm({
  groupId,
  question_id,
  question,
  label,
  answer,
  answerCheckbox,
  onChange,
  required,
}: Props) {
  const [checkBox, setCheckBox] = React.useState<boolean | null>(answerCheckbox);
  const { translations } = useTranslation();

  const handleCheckBox = (checkBoxVal: boolean | null) => {
    if (checkBoxVal === null) {
      onChange(groupId, question_id, '', null);
    } else if (!checkBoxVal) {
      onChange(groupId, question_id, '', false);
    } else {
      onChange(groupId, question_id, answer, true);
    }
    setCheckBox(checkBoxVal);
  };

  const checkboxClass = (param: string) => {
    if (checkBox === null) {
      return `${styles.checkBox}`;
    }
    if (param === 'no') {
      return checkBox === false ? `${styles.checkBox} ${styles.checked}` : `${styles.checkBox}`;
    }
    if (param === 'yes') {
      return checkBox === true ? `${styles.checkBox} ${styles.checked}` : `${styles.checkBox}`;
    }
  };

  return (
    <div className={styles.questionContainer}>
      <div className={styles.questionWrap}>
        <p className={styles.question}>{question}</p>
        {!required && <p className={styles.optional}>({translations("label.optional")})</p>}
      </div>
      <div className={styles.form}>
        <div className={styles.textBoxWrap}>
          <span className={styles.label}>{translations("no")}</span>
          <div
            className={checkboxClass('no')}
            onClick={() => (checkBox === false ? handleCheckBox(null) : handleCheckBox(false))}
          ></div>
        </div>
        <div className={styles.textBoxWrap}>
          <span className={styles.label}>{translations("yes")}</span>
          <div
            className={checkboxClass('yes')}
            onClick={() => (checkBox ? handleCheckBox(null) : handleCheckBox(true))}
          ></div>
        </div>
        <div className={styles.textBoxWrap} style={{ width: '100%' }}>
          <span className={styles.label}>{label}</span>
          <input
            className={styles.textBox}
            onChange={(e: any) => onChange(groupId, question_id, e.target.value, checkBox)}
            value={answer}
            disabled={!checkBox}
          />
        </div>
      </div>
    </div>
  );
}
